// For an accrual-mode type (ANNUAL), the API attaches a live `accrued` figure (how much
// has actually accrued so far this year) that's smaller than `allocated` (the eventual
// full-year cap) for most of the year -- see computeAccruedAnnual in the API's
// leave-policy.service.ts. Every other leave type has `accrued === allocated` always, so
// this is safe to use everywhere "available" used to mean `allocated - used - pending`.
export function availableDays(row: { allocated: number | string; used: number | string; pending: number | string; accrued?: number | string }): number {
  const base = row.accrued !== undefined ? Number(row.accrued) : Number(row.allocated);
  // Floor at 0 -- a pre-existing used/pending amount can exceed a newly-lower accrued
  // cap (e.g. a request made before monthly accrual applied). Never display negative.
  return Math.max(0, base - Number(row.used) - Number(row.pending));
}
